module.exports = __webpack_public_path__ + "img/2.f8f31200.jpg";